module.exports = __webpack_public_path__ + "img/hero-slide-3.9ff52522.svg";